import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'

dayjs.extend(customParseFormat)

export const getWeekDates = ({ addWeek = false }) => {
  const dayId = dayjs().day()
  const addDays = addWeek ? 8 : 1
  return Array(7)
    .fill(0)
    .map((_, i) => {
      return {
        day_id: i === 6 ? 0 : i + 1,
        date: dayjs()
          .startOf('week')
          .subtract(dayId === 0 ? 1 : 0, 'week')
          .add(i + addDays, 'day')
          .format('YYYY-MM-DD'),
      }
    })
}

export const formatOpeningTimes = ({ open, close }) => `${dayjs(
  open,
  'HH:mm:ss'
).format('h:mma')} - 
${dayjs(close, 'HH:mm:ss').format('h:mma')}
`

export const isToday = id => dayjs().day() === id

const getFormattedTime = date => date?.split(':')

const isClosed = date => {
  const [openHours, openMinutes, openSeconds] =
    getFormattedTime(date?.open) || []
  const [closeHours, closeMinutes, closeSeconds] =
    getFormattedTime(date?.close) || []

  const openTime = new Date()
  openTime.setHours(openHours, openMinutes, openSeconds)
  const closeTime = new Date()
  closeTime.setHours(closeHours, closeMinutes, closeSeconds)

  return (
    dayjs()
      .subtract(closeHours === '00' ? 1 : 0, 'day')
      .isAfter(closeTime) || dayjs().isBefore(openTime)
  )
}

export const getTodaysDate = (supermarketSpecialTimes, openingTimes) => {
  if (!openingTimes?.length) return null
  const currentWeek = getWeekDates({ addWeek: false })
  const specialDate = supermarketSpecialTimes?.specialOpeningTimes.find(
    itm => itm.date === currentWeek.find(t => isToday(t.day_id))?.date
  )
  const today = openingTimes.find(t => isToday(t.day_id))

  const isClosedSpecialDay = isClosed(specialDate)
  const isClosedToday = isClosed(today)
  const storeIsClosed =
    today?.open === '00:00:00' && today?.close === '00:00:00'

  if (specialDate) {
    if (specialDate?.closed) {
      return 'Store closed today'
    } else {
      return `${
        isClosedSpecialDay ? 'Store closed / ' : ''
      } Open Today: ${formatOpeningTimes({
        open: specialDate.open,
        close: specialDate.close,
      })}`
    }
  } else if (storeIsClosed) {
    return 'Store closed'
  } else {
    return `${
      isClosedToday ? 'Store closed / ' : ''
    } Open Today: ${formatOpeningTimes({
      open: today.open,
      close: today.close,
    })}`
  }
}
